import styled from 'styled-components';

export const NextInvoiceWrapper = styled.div`
  color: #a0a0a7;
  font-size: 15px;
  font-weight: 400;
  line-height: 30px;
`;

export const NextInvoiceTitle = styled.div`
  text-transform: uppercase;
  font-size: 12px;
`;
export const NextInvoiceDate = styled.div``;
